module.exports = __webpack_public_path__ + "static/img/Frame_4108@2x(2).b65c5fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/service/Frame_4108@2x(2).png
// module id = TuCw
// module chunks = 59